/**
 * FolderIcon Component
 * Folder icon for SetupQuestionaryPage
 */

import setupQuestionaryFolderImage from '../../assets/images/setupQuestionaryFolder.png'
import setupQuestionaryFolderImage2x from '../../assets/images/setupQuestionaryFolder@2x.png'

interface FolderIconProps {
  size?: number
  className?: string
}

export const FolderIcon = ({ size = 100, className = '' }: FolderIconProps) => (
  <img
    src={setupQuestionaryFolderImage}
    srcSet={`${setupQuestionaryFolderImage} 1x, ${setupQuestionaryFolderImage2x} 2x`}
    alt="Folder"
    className={className}
    style={{
      width: size,
      height: size,
    }}
  />
)
